<template>
	<el-dialog 
        title="" 
        :visible.sync='isShow' 
        width="700px"
        id='QRcodeDialog'
        append-to-body
		:show-close="false"
        >
        <div id="QRcode">
			<img src="/static/img/qrCode_close.png" alt="" width="32px" height="32px" class="close_icon" @click="isShow = false">
        	<!-- <div class='leftText'>
        		其他成员若需登录，需管理员在“系统设置-成员管理”分配拥有“微信小程序”权限的角色；
        	</div>
        	<div class='rightText'>
        		关注公众号可以接收重要财务数据推送和行业、产品最新信息
        	</div> -->
		</div>
    </el-dialog>
	
</template>
<script>
	export default {
		props:{
			isQrCodeShow:Boolean
		},
		data() {
			return {
				
			}
		},
		created() {
			
		},
		computed:{
			// 显示弹窗
			isShow: {
				get () {
					return this.isQrCodeShow;
				},
				set (val) {
					this.$emit('update:isQrCodeShow', val);
				}
			},
		},
		methods: {

		},
	}
</script>
<style lang="less">
	#QRcodeDialog {
		// .el-dialog__header {
		// 	.el-dialog__title {
		// 		font-weight: 600;
		// 		color: #269D7B;
		// 	}
		// }
		
		.el-dialog__header,.el-dialog__body {
			padding: 0 !important;
		}
		#QRcode {
			height: 400px;
			background: url('/static/img/qrCode.png') no-repeat;
			background-size: 100% 100%;
			position: relative;
			.close_icon {
				position: absolute;
				top: -42px;
				right: 0;
			}
		}
	}
	
</style>


// WEBPACK FOOTER //
// src/components/dialog/QrCode.vue